import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import Select from "react-select"

import { getEmployes } from "../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";




const AddBouns = ({
  name, amount, issue_date,amount_Type,setName,setAmount,paid,setIssueDate,setAmount_type,setPaidDate, hr_attendance_id ,setHrAttendanceId,setPaid  ,paid_date ,setDate,date,setSbEmployeId
}) => {

  const {t} =useTranslation()
  const DescriptionIcon = icons.description;
  const LevelIcon = icons.levels;

 const amountTypes = ["amount" , "percent","days"]
 const {data , isLoading} =useQuery("gettEmployes", getEmployes)
 const employes =data?.data ||[]
  const handleNameChange = (e) => {
    const { value } = e.target;
    setName(value);
  };
  const handleSelectedAmountTypeChange = (e) => {
    const { value } = e.target
    setAmount_type(value);
  };

  const handleAmountChange = (e) => {
    const { value } = e.target;
    setAmount(value);    
  };
  const handelChangeIssueDate =(e)=>{
    const {value} =e.target
    setIssueDate(value)
  }
  const handelPaidDate =(e)=>{
    const {value} =e.target
    setPaidDate(value)
  }
const handelDateChange=(e)=>{
  const {value} =e.target
  setDate(value)
}

  const handlePaidChange = (e) => {
    const isChecked = e.target.checked;
    setPaid(isChecked ? 1 : 0);
  };
const handleEmployeIdChange =(selectedOption)=>{
  const employeId =selectedOption ?selectedOption.id :null
  setSbEmployeId(employeId)
}




  return (
    <div className="row">
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Name")} </label>
              <div className={classes.iconInput}>
                <LevelIcon />
              </div>
              <input
                type="text"
                value={name}
                placeholder="ادخل  الاسم"
                onChange={handleNameChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Employe")} </label>
             <Select getOptionValue={(e)=>e.id} getOptionLabel={(e)=>e.name_ar}  options={employes} onChange={handleEmployeIdChange}/>
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Amount")} </label>
              <div className={classes.iconInput}>
                <DescriptionIcon />
              </div>
              <input
                type="number"
                placeholder={t("Enter Amount")}
                onChange={handleAmountChange}
                value={amount}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
            <label htmlFor=""> {t("Date")}</label>
            <input type="date" value={date}  onChange={handelDateChange}  className={classes.inputCustom}/>

            </div>
            <div className={classes.formCol}>
              <label htmlFor="">{t("Amount_Type")} </label>
              <div className={classes.iconInput}>
                <DescriptionIcon />
              </div>
              <select
                onChange={handleSelectedAmountTypeChange}
                value={amount_Type}
                className={classes.inputCustom}>
                <option value="">{t("Choose Type")}</option>
                {amountTypes.map((type, i) => (
                  <option value={type} key={i}>
                    {" "}
                    {type}
                  </option>
                ))}
              </select>
            </div>  
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
         

            <div className={classes.formCol}>
            <label htmlFor=""> {t("Issue_Date")}</label>
            <input type="date" value={issue_date}  onChange={handelChangeIssueDate}  className={classes.inputCustom}/>

            </div>
              
           

           {paid ===1 && <div className={classes.formCol}>
              <label htmlFor="">{t("PaidDate")}</label>
               <input type="date" value={paid_date} onChange={handelPaidDate}   className={classes.inputCustom} />
            </div>}
            <div className={classes.formCol}> 
           <label htmlFor="" className={paid ? `${classes.active}` : `${classes.disActive}`}> {paid===1 ?"مدفوع":"غير مدفوع"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handlePaidChange} checked={paid}/>
             <span class="slider round"></span>
         </label>   
        </div>

          
          </div>
        </div>
      </div>
    </div>
  );
};  

export default AddBouns;

